import { IIconProps } from "@/components/icons/interface";

const HpFileInputIcon = ({ width, height, color }: IIconProps) => {
  const strokeColor = color ?? "var(--theme-combobox-icon-color, #1A1A1A)";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-file-input-icon lucide-file-input"
      aria-hidden
    >
      <path d="M4 11V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1" />
      <path d="M14 2v5a1 1 0 0 0 1 1h5" />
      <path d="M2 15h10" />
      <path d="m9 18 3-3-3-3" />
    </svg>
  );
};

export { HpFileInputIcon };
